const messages = {
  bonus: {
    title: "Bonusa kredītu pārskats",
    description: "Bonusi eiro tiek piešķirti iesaistītajiem uzņēmumiem, pamatojoties uz iesniegtajiem pārdošanas datiem.",
    lastMonth: "Pagājušais mēnesis",
    currentMonth: "Pašreizējais mēnesis",
    totalCurrentYear: "Kopā šajā gadā",
    totalLastYear: "Kopā pagājušajā gadā",
  },
  points: {
    title: "Punktu kredītu pārskats",
    period: "Tekošais kalendārais gads ({year})",
    totalAwarded: "Kopā piešķirtie punkti",
    redeemed: "Izmantotie punkti",
    totalBalance: "Kopējais punktu atlikums",
    redemptionRate: "Izmantotie punkti kā procentuālā daļa no piešķirtajiem punktiem",
    averageAwarded: "Vidēji piešķirtie punkti uz vienu nopirktu riepu",
    standardAwarded: "Neto punkti no aprēķinātajām pārdošanas rindām, ieskaitot atgriešanas",
    bsPlusInclBooster: "Punkti no pārdošanas rindām ar pozitīvu daudzumu",
    perTire: "Izmantotie punkti uz vienu nopirktu riepu",
  },
  tires: {
    title: "Riepu daudzuma pārskats",
    description: "Klientu iegādātās riepas",
    prevMonth: "Iepriekšējais mēnesis",
    totalLastYear: "Kopā pagājušajā gadā",
    purchaseIndirect: "Pirkums caur vairumtirgotāju (netieši)",
    purchaseDirect: "Pirkums caur vairumtirgotāju (tieši)",
    totalCurrentYear: "Kopā šajā gadā",
    currentMonth: "Pašreizējais mēnesis",
  },
  participating: {
    title: "Iesaistīto klientu pārskats",
    description: "Uzņēmumi, kas reģistrējas BRIDGESTONE PLUS, var tikt piesaistīti pēc klienta numura.",
    total: "Kopā",
    newThisMonth: "Jauni šajā mēnesī",
    newThisYear: "Jauni šajā gadā",
    createdInCurrentMonth: "Izveidoti šajā mēnesī (administrators)",
    loginsCurrentYear: "Pieslēgšanās šajā gadā (pēc noteikumu pieņemšanas)",
  },
  brand: {
    title: "Zīmols",
    description: "Jūsu pirkumi detalizēti",
    centerTitle: "Pēc\nzīmola",
  },
  rim: {
    title: "Disks",
    centerTitle: "Pēc diska\nizmēra",
  },
  tireGoals: {
    title: "Riepu mērķi",
    subtitle: "Krājiet punktus par riepu pirkumiem.",
    centerTitle: "Pēc riepas\nizmēra",
    tiresRemaining: "Atlikušās riepas",
    progressionTarget: "Progresa mērķis: ",
    pointsEarnedPurchases: "punkti, kas nopelnīti\n" + "par jūsu\n" + "pirkumiem",
    pointsEarnedBoosters: "punkti, kas nopelnīti\n" + "ar\n" + "boosteriem",
    purchasesDetail: "Jūsu pirkumi detalizēti",
    cta: "Uzziniet vairāk par saviem punktiem",
    pointsTitle: "Jūsu punkti",
    pointsSubtitle: "Punkti, kas nopelnīti par Bridgestone pirkumiem",
    achievementsTitle: "Jūsu sasniegumi",
    achievementsSubtitle: "Jūsu gada saistības:",
    achievementsSubtitle2: "riepas",
  },
  score: {
    title: "Rezultāts",
    total: "Kopā",
    credits: "Kredīti",
    deductions: "Atskaitījumi",
        unlockedPoints: "Atbloķētie punkti",
        pendingPoints: "Gaidošie punkti",
  },
  score_extended: {
    title1: "Punktu atlikums",
    title2: "Bonuss eiro",
    balance: "Punktu atlikums",
    bonus_in_euro: "Bonuss eiro",
    date: "Datums",
    added_points: "Pievienotie punkti",
    total_bands: "Kopā zīmolu",
    goal: "Mērķis",
    tyres_previous_year: "Pagājušajā gadā pārdotās riepas",
    tyres_current_year: "Šogad pārdotās riepas",
    target_this_year: "Šī gada pārdošanas mērķis",
    bonus_this_year: "Nopelnītais bonuss (€)",
    loyal_minimum: "Minimālais lojalitātes līmenis",
    bonus_multiplier: "Bonusa reizinātāja likme",
  },
  lastImport: {
    label: "Pēdējais pārdošanas datu imports:",
    on: "",
  },
  wholesalerTable: {
    title: "Iesaistītie klienti detalizēti",
    description: "Zemāk atradīsiet uzņēmumus, kas reģistrējušies BRIDGESTONE PLUS ar jūsu uzņēmuma klienta numuru. Varat izmantot filtrus citai kārtošanai vai meklēšanu klientu atrašanai.",
    columns: {
      customer_number: "Klienta Nr.",
      address_company_name: "Uzņēmums",
      address_street: "Iela un mājas nr.",
      address_postal_code: "Pasta indekss",
      address_city: "Pilsēta",
      last_registration: "Pēdējā reģistrācija",
      network: "Tīkls",
      profile_group: "Grupa",
      tires_amount: "Riepu daudzums",
      point_balance: "Punktu atlikums",
      bonus: "Bonuss",
      details: "Detaļas",
    },
    searchPlaceholder: "Meklēt",
  },
  dealerTable: {
    columns: {
      date: "Datums",
      wholesaler_bs_plus: "Vairumtirgotājs BS+",
      customer_number: "Klienta numurs",
      article: "Prece",
      brand: "Zīmols",
      product: "Produkts",
      type: "Tips",
      inch: "Collas",
      season: "Sezona",
      amount: "Daudzums",
      points: "Punkti",
      activity: "Aktivitāte",
      total_points: "Punkti kopā",
    },
    title: "Dīleru tabula",
    description: "Dīleru aktivitāšu pārskats",
  },
  business_units: {
    title: "Biznesa vienības",
    centerTitle: "Pēc\nvienības",
  },
  season: {
    title: "Sezona",
    centerTitle: "Pēc gada\nlaika",
  },
};

export default {
  messages,
};
